import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { HiChat, HiChatAlt2, HiXCircle, HiOutlineUsers } from 'react-icons/hi';
import { BiBot, BiUserCircle, BiX, BiTired } from 'react-icons/bi';
import { Title } from './styled';
import { StatisticsViewingCard } from 'components/StatisticsViewingCard';
import { useSocketLoggedAttendants } from '../../hooks/useSocketLoggedAttendants';

export const MonitoringHeaderChat = ({ dataToShow }) => {
  const { loggedAttendants } = useSocketLoggedAttendants();

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const primary_color = systemConfiguration.primary_color;

  return (
    <>
      <div
        className="header header-dark pb-6 content__title content__title--calendar"
        style={{
          backgroundColor: primary_color
        }}
      >
        <Container fluid>
          <div className="header-body">
            <Title>Painel de Atendimentos</Title>
            <Row>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Total de Conversas"
                  icon={<HiChatAlt2 size={35} color={primary_color} />}
                  data={dataToShow.qtdTotalConversations}
                />
              </Col>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Não Atendidas"
                  tooltip="Total de conversas não atendidas"
                  icon={<HiXCircle size={35} color={primary_color} />}
                  data={`${dataToShow.qtdTotalMissed} / ${dataToShow.qtdTotalConversations}`}
                />
              </Col>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Em Atendimento"
                  tooltip="Total de conversas em atendimento"
                  icon={<HiChat size={35} color={primary_color} />}
                  data={`${dataToShow.qtdTotalInAttendance} / ${dataToShow.qtdTotalConversations}`}
                />
              </Col>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Atendimento Bot"
                  tooltip="Total de conversas com atendimento bot"
                  icon={<BiBot size={35} color={primary_color} />}
                  data={`${dataToShow.qtdTotalBot} / ${dataToShow.qtdTotalInAttendance}`}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Encerradas Hoje"
                  tooltip="Total de conversas encerradas hoje"
                  icon={<BiX size={35} color={primary_color} />}
                  data={dataToShow.qtdEnded}
                />
              </Col>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Abandonadas Hoje"
                  tooltip="Total de conversas abandonadas hoje"
                  icon={<BiTired size={35} color={primary_color} />}
                  data={dataToShow.qtdAbandonadas}
                />
              </Col>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Usuários Logados"
                  tooltip="Total usuários logados"
                  icon={<HiOutlineUsers size={35} color={primary_color} />}
                  data={loggedAttendants.length}
                />
              </Col>
              <Col md="6" xl="3">
                <StatisticsViewingCard
                  title="Atendimento Humano"
                  tooltip="Total de conversas com atendimentos humanos"
                  icon={<BiUserCircle size={35} color={primary_color} />}
                  data={`${dataToShow.qtdTotalHuman} / ${dataToShow.qtdTotalInAttendance}`}
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
